export default {
      id: "ic_add-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_add",
      toString: function () {
        return this.url;
      }
    }